import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/** @jsxImportSource @emotion/react */
import { Typography } from "@vc-workspace/utils-typography";
import { bannerImageContainer, bannerImageStyles, containerStyles, headingContainerStyles } from "./category-page-hero.module.style";
import { useContext } from "react";
import { CategoryContext } from "../global-context-wrapper/global-context-wrapper";
import BreadCrumbs from '../breadcrumbs/breadcrumbs';
import { UtilsSeparator } from "@vc-workspace/utils-separator";
import { DIMENSIONS } from "@vc-workspace/utils-dimens";
import SortFilterDropdownMenu from "../sort-filter-dropdown-menu/sort-filter-dropdown-menu";
import { ImageAccessibility, ImageTypes } from "@vc-workspace/utils-constants";
import { getImagesByType } from "@vc-workspace/utils-helpers";
import L1FeaturedCategories from "../l1-featured-categories/l1-featured-categories";
/* eslint-disable-next-line */

function getPageBreadCrumbs(allCategories, currCategory) {
  var breadcrumbs = [];

  if (!allCategories.length) {
    return breadcrumbs;
  }

  breadcrumbs.push({
    label: currCategory.displayName
  });
  var currentCategoryId = currCategory.parent;

  while (currentCategoryId) {
    var category = allCategories.filter(function (item) {
      return item._id === currentCategoryId;
    })[0];

    if (category && category.level !== 0) {
      breadcrumbs.push({
        label: category.displayName,
        url: "/category/".concat(category.slug)
      });
    }

    currentCategoryId = category === null || category === void 0 ? void 0 : category.parent;
  }

  breadcrumbs = breadcrumbs.reverse();
  return breadcrumbs;
}

export function CategoryPageHero(props) {
  var _useContext = useContext(CategoryContext),
      categories = _useContext.categories;

  var imageType = props.context.isMobileView ? ImageAccessibility.Mobile : ImageAccessibility.Desktop;
  var bannerImage = getImagesByType(props.category.images, ImageTypes.Banner, "3", imageType, true);
  var hasBannerImage = Boolean(bannerImage.url);
  var isLevelOneCategory = props.category.level === 1;
  return _jsxs(_Fragment, {
    children: [_jsxs("div", {
      css: containerStyles(hasBannerImage),
      children: [hasBannerImage ? _jsx("div", {
        css: bannerImageContainer,
        children: _jsxs("picture", {
          children: [_jsx("source", {
            srcSet: bannerImage.webP,
            type: "image/webp"
          }), _jsx("img", {
            src: bannerImage.url,
            css: bannerImageStyles
          })]
        })
      }) : null, _jsx("div", {
        css: isLevelOneCategory ? headingContainerStyles : null,
        children: _jsxs("div", {
          className: "page-cushion-container pure-g",
          children: [_jsxs("div", {
            className: "pure-u-1 ".concat(isLevelOneCategory ? "mb-12" : ""),
            children: [props.category.level === 2 ? _jsx(BreadCrumbs, {
              breadcrumbList: getPageBreadCrumbs(categories, props.category)
            }) : null, _jsx(Typography, {
              type: props.context.isMobileView ? "Headline_H1" : "Heading3",
              className: isLevelOneCategory ? "text-center mt-4" : "",
              color: "nero",
              bold: true,
              children: props.category.displayName
            })]
          }), isLevelOneCategory && props.featuredCategories && props.featuredCategories.length ? _jsx("div", {
            className: "pure-u-1 pb-12",
            children: _jsx(L1FeaturedCategories, {
              categories: props.featuredCategories,
              context: props.context
            })
          }) : null, !props.context.isMobileView || !isLevelOneCategory ? _jsx("div", {
            className: "pure-u-1-2 flex items-start",
            children: _jsxs(Typography, {
              type: "SubHeading1",
              color: "dim_grey",
              className: "pt-1",
              semi_bold: true,
              children: [props.siasCount, " Products"]
            })
          }) : null, !props.context.isMobileView ? _jsx("div", {
            className: "pure-u-1-2 flex items-end justify-end",
            children: _jsx(SortFilterDropdownMenu, {
              context: props.context,
              whiteTheme: isLevelOneCategory
            })
          }) : null]
        })
      })]
    }), !props.context.isMobileView || !isLevelOneCategory ? _jsx("div", {
      className: "page-cushion-container",
      children: _jsx(UtilsSeparator, {
        spacingTop: props.context.isMobileView ? DIMENSIONS.px_16 : DIMENSIONS.px_24,
        spacingBottom: DIMENSIONS.px_24,
        color: "gainsboro"
      })
    }) : null]
  });
}
export default CategoryPageHero;